import { render, staticRenderFns } from "./TextAreaAccordeon.vue?vue&type=template&id=b4ee8176&"
import script from "./TextAreaAccordeon.vue?vue&type=script&lang=js&"
export * from "./TextAreaAccordeon.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaAccordeon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports